import { routes } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
import { getEntityRegistration } from '@shared/utils/entityRegistration';
export const generateUrlNavigation = (buildHref, options)=>{
    const { type, params, query } = options;
    const entityType = Constants.EntityType[`${type}`];
    const isPartner = entityType === Constants.EntityType.Partner;
    const route = isPartner ? routes.marketplacePartners : entityType ? getEntityRegistration(entityType).route : routes[`${type}`];
    if (!route) {
        return '';
    }
    if (route.name === routes.marketplacePartnerSuggestion.name) {
        return buildHref(route, null, query);
    } else {
        return buildHref(route, params, query, false, true);
    }
};
